import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollableComponent } from './scrollable/scrollable.component';

@NgModule({
    declarations: [ScrollableComponent],
    imports: [CommonModule ],
    exports: [ScrollableComponent],
})
export class ScrollableModule {}
